import React from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend
} from "recharts";

export const MonthlyBarChart = ({ data }: any) => {
  return (
    <LineChart
      width={1200}
      height={500}
      data={data}
      margin={{
        top: 5,
        right: 30,
        left: 20,
        bottom: 5
      }}
    >
      {/* <CartesianGrid strokeDasharray="3 3" /> */}
      <XAxis dataKey="date" angle={-45} interval={0} tick={{ fontSize: 12, fontWeight: 'bold' }} height={65} dy={25} dx={-25} />
      <YAxis />
      <Tooltip />
      {/* <Legend /> */}
      <Line type="linear" dataKey="count" stroke="#8884d8" strokeWidth={3} dot={false}  />
    </LineChart>
  );
};
